import React, { Component } from "react";
import {
  GoogleMap,
  Marker,
  withScriptjs,
  withGoogleMap
} from "react-google-maps";
import mapStyle from "utils/mapstyles/paleDawnMapStyle.json";
import markerIcon from "images/mapmarker.png";

const GoogleMapComponent = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{
        lat: 34.1940158,
        lng: -118.33483639999997
      }}
      defaultOptions={{ styles: mapStyle }}
    >
      {props.isMarkerShown && (
        <Marker
          position={{
            lat: 34.1940158,
            lng: -118.33483639999997
          }}
          icon={markerIcon}
        />
      )}
    </GoogleMap>
  ))
);

class GoogleMapContainer extends Component {
  state = {
    isMarkerShown: false
  };

  componentDidMount() {
    this.delayedShowMarker();
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 1);
  };

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false });
    this.delayedShowMarker();
  };

  render() {
    return (
      <GoogleMapComponent
        isMarkerShown={this.state.isMarkerShown}
        onMarkerClick={this.handleMarkerClick}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&v=3.exp&libraries=geometry,drawing,places`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `400px` }} className="card" />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    );
  }
}

export default GoogleMapContainer;



// WEBPACK FOOTER //
// ./src/pages/About/components/GoogleMap.js